"use strict";
/**
 * To update enum/file run next SQL command in data-drip

 select CONCAT('export enum WbfUsers {',actor_list,'}') as copy_me
 from (SELECT 1, string_agg(CONCAT('"', "user"."firstName",' ',"user"."lastName", '"', ' = ', '"', id, '"'), ', ') AS actor_list
 FROM "user"
 where "user".type='integration'
 GROUP BY 1) as list;

 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WbfUsers = void 0;
// <GENERATED
var WbfUsers;
(function (WbfUsers) {
    WbfUsers["Person Himself Integration"] = "368b70b8-7ed7-4407-b508-bad22523ef49";
    WbfUsers["WBF Databricks Integration"] = "5e3ae40a-8aa4-43a3-86d7-e3737fc1c82f";
    WbfUsers["WBF AON Integration"] = "eeca3c58-89e8-4fce-80f2-033c5bfdd308";
    WbfUsers["WBF Benestream Integration"] = "6cd86972-2a2d-4c6a-99e6-0307dc4bf663";
    WbfUsers["WBF DataLoader Integration"] = "8dd1ff54-6cf0-485e-8afd-541d2f90954b";
    WbfUsers["User Deleted"] = "c9cee6fa-0a3e-473b-9553-16d6fc3cf794";
    WbfUsers["DU Integration"] = "bc1474c1-5be0-4882-8ccc-c6c99bdd8340";
    WbfUsers["Engage Integration"] = "0a1f317b-11b0-4d33-b0f7-cef90933ef8e";
    WbfUsers["WBF Exodus Integration"] = "ba2e60ca-d4de-4f1f-8d98-ee7ce4874b42";
    WbfUsers["Form  Auto-process"] = "8c6f54ad-7378-4c38-a9f8-64589d6d9587";
    WbfUsers["WBF Inshur Integration"] = "bd3376fb-9e35-473e-be8b-612ee82de183";
    WbfUsers["Internal Integration"] = "590820d3-02a5-4423-90db-12a715f42f22";
    WbfUsers["WBF Lyft  Integration"] = "9055cd30-0383-4a80-9ea7-1461323994e9";
    WbfUsers["WBF Member Resources Integration"] = "36f54fef-7b2f-4266-adc4-6b39f9ae4bd3";
    WbfUsers["WBF MetroPlus Integration"] = "4b8c0ec6-90e3-4e76-937e-dafc050bc5db";
    WbfUsers["Tickets Integration"] = "43d560c1-11b7-445f-9ea2-7820751f2f1c";
})(WbfUsers || (exports.WbfUsers = WbfUsers = {}));
// >
//# sourceMappingURL=wbf-users.js.map